<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />

    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card title="Locations">
        <template slot="actions">
          <va-button @click="printerModalState(true)" icon="fa fa-plus"/>
        </template>
        <div class="va-card__body" v-if="printers.length < 1 || !isAuthenticated">
          <va-notification v-if="printers.length < 1" color="info">
            <va-badge color="info">
              {{ $t('badges.info') }}
            </va-badge>
            {{ $t('printers.notFound') }}
          </va-notification>
          <va-notification v-if="!isAuthenticated" color="info">
            <va-badge color="info">
              {{ $t('badges.info') }}
            </va-badge>
            {{ $t('printers.authenticate') }}
            <div class="ml-1 link" @click="googleAuthorization">
              <va-icon
                name="fa fa-google"
              />
              {{ $t('printers.googleCloud') }}
            </div>
          </va-notification>
        </div>
      </va-card>
    </div>

    <div v-if="!this.$store.getters.isLoading && printers.length > 0" class="flex xs12">
      <va-card stripe="primary">
        <va-list fit class="mb-2">
          <div v-for="(printer, index) in printers" v-bind:key="printer.eventPrinterId">
            <va-item :key="'item' + printer.eventPrinterId" clickable>
              <va-item-section>
                <va-item-label>
                  {{ printer.name }}
                </va-item-label>
              </va-item-section>

              <va-item-section>
                <va-item-label>
                  <va-item-label caption>
                    {{ printer.id }}
                  </va-item-label>
                  <va-item-label>
                    <strong>{{ printer.proxy }} - {{ printer.manufacturer }}</strong>
                  </va-item-label>
                </va-item-label>
              </va-item-section>
              <va-item-section side @click="removePrinter(printer.eventPrinterId, index)">
                <va-icon name="fa fa-trash"></va-icon> {{ $t('printers.remove') }}
              </va-item-section>
              <!--              <va-item-section side>-->
              <!--                <va-popover-->
              <!--                  placement="right"-->
              <!--                  message="User assigned to this location"-->
              <!--                >-->
              <!--                  <va-icon name="fa fa-user"> <span class="locCounts">{{ location.userCount }}</span></va-icon>-->
              <!--                </va-popover>-->
              <!--              </va-item-section>-->
              <!--              <va-item-section side>-->
              <!--                <va-popover-->
              <!--                  placement="right"-->
              <!--                  message="Active clients on this location"-->
              <!--                >-->
              <!--                  <va-icon name="fa fa-users"> <span class="locCounts">{{ location.clientCount }}</span></va-icon>-->
              <!--                </va-popover>-->
              <!--              </va-item-section>-->
            </va-item>

            <va-list-separator v-if="index < printer.length - 1" :key="'separator' + printer.eventPrinterId" />
          </div>
        </va-list>
      </va-card>
    </div>
    <va-modal
      v-model="printerCreateModal"
      :title="$t('printers.addPrinter')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <SwappingSquaresSpinner v-if="modalLoader"
        :animation-duration="1000"
        :size="90"
        :color="this.$store.getters.config.palette.primary"
        style="margin: 30px auto;"
      />
      <form v-if="!modalLoader">
        <div class="row">
          <div class="flex xs12">
            <va-input
              v-model="printerProxy"
              type="text"
              :label="$t('printers.printerProxy')"
              :error="!!printerProxyErrors.length"
              :error-messages="printerProxyErrors"
            />
          </div>
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button color="gray" @click.prevent="printerModalState(false)" class="my-0 ">{{ $t('printers.btnClose') }}</va-button>
          <va-button type="submit" @click.prevent="onsubmit()" class="my-0">{{ $t('printers.btnCreate') }}</va-button>
        </div>
      </form>
    </va-modal>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'LocationPrinters',
  data () {
    return {
      printerCreateModal: false,
      printers: [],
      locationId: 0,
      isAuthenticated: true,
      printerProxy: '',
      printerProxyErrors: [],
      modalLoader: false,
    }
  },
  methods: {
    onsubmit () {
      this.printerProxyErrors = this.printerProxy ? [] : [this.$t('printers.requiredPrinter')]
      if (this.printerProxyErrors.length > 0) {
        return
      }
      this.modalLoader = true
      this.$store.dispatch('createPrinter', {
        locationId: this.locationId,
        message: {
          printerProxy: this.printerProxy,
        },
      }).then((err) => this.errorHandler(err.response))
    },
    removePrinter (eventPrinterId, index) {
      this.$store.dispatch('deletePrinter', eventPrinterId)
        .then(() => this.printers.splice(index, 1))
        .catch((err) => this.errorHandler(err.response))
    },
    printerModalState (state) {
      this.printerCreateModal = state
      if (!state) {
        this.printerProxy = ''
      }
    },
    async googleAuthorization () {
      const authCode = await this.$gAuth.getAuthCode()
      // await this.$gAuth.signIn()
      this.$store.commit('setLoading', true)
      this.$store.dispatch('printersAuthentication', {
        authCode: authCode,
      }).catch((error) => this.errorHandler(error.response))
    },
    async initPrinters (printers) {
      this.printers.splice(0, this.printers.length, ...printers)
      this.$store.commit('setLoading', false)
    },
    toDashboard () {
      this.$router.push({
        name: 'dashboard',
      })
    },
    notThisLocation () {
      this.toDashboard()
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.locationId = Number.parseInt(this.$route.params.locationId)
    if (!this.locationId) {
      this.toDashboard()
    }
    this.$store.dispatch('getLocation', this.$route.params.locationId).catch(this.notThisLocation)
      .then(() => this.$store.dispatch('checkAuth', this.$route.params.locationId))
      // eslint-disable-next-line handle-callback-err
      .catch((err) => {
        this.isAuthenticated = false
        this.$store.commit('setLoading', false)
      })
      .then(() => this.$store.dispatch('getPrinters', this.$route.params.locationId))
      .then((resp) => this.initPrinters(resp.data.message))
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style scoped>

</style>
